import React, { useEffect, useState } from 'react'
import { MdArrowForward } from 'react-icons/md'
import { ConfigFiltersLayoutProps } from '../types'
import FilterChipBar from './FilterChipBar'
import FilterOptionList from '../shared/FilterOptionList'
import Button from '../../../../../components/Buttons/Button'

const ConfigFiltersMobile = ({ chainColumns, independentColumns }: ConfigFiltersLayoutProps) => {
    const [selectedTitle, setSelectedTitle] = useState(chainColumns[0]?.title)

    // Si la columna elegida se deshabilitó (ej: se usó "Limpiar"), se pasa a la última columna habilitada
    useEffect(() => {
        const selected = chainColumns.find(col => col.title === selectedTitle)
        if (selected && !selected.visible) {
            const lastVisible = chainColumns.filter(col => col.visible).pop()
            if (lastVisible) setSelectedTitle(lastVisible.title)
        }
    }, [chainColumns, selectedTitle])

    const selectedColumn = [...chainColumns, ...independentColumns].find(col => col.title === selectedTitle)

    // Siguiente nodo del árbol (solo para las columnas en cadena)
    const chainIndex = chainColumns.findIndex(col => col.title === selectedTitle)
    const nextColumn = chainIndex >= 0 ? chainColumns[chainIndex + 1] : undefined

    return (
        <>
            <FilterChipBar
                chainColumns={chainColumns}
                independentColumns={independentColumns}
                selectedTitle={selectedTitle}
                onSelect={setSelectedTitle}
            />
            {selectedColumn && (
                <>
                    <div className='p-4'>
                        <h3 className='text-brand-green-30 text-tsmall uppercase'>{selectedColumn.title}</h3>
                    </div>
                    <FilterOptionList
                        key={selectedTitle}
                        {...selectedColumn}
                        showArrow={false}
                        bgSelected={false}
                        className='max-h-[min(50vh,calc(100dvh_-_22rem))]'
                    />
                    {nextColumn && selectedColumn.selectedValues.length > 0 && (
                        <div className='p-4'>
                            <Button
                                label={`Continuar a ${nextColumn.title}`}
                                type='button'
                                variant='outline-black-green'
                                showIconLeft={false}
                                showIconRight={true}
                                icon={MdArrowForward}
                                iconSize={18}
                                disabled={!nextColumn.visible}
                                onClick={() => setSelectedTitle(nextColumn.title)}
                                className='!w-full'
                            />
                        </div>
                    )}
                </>
            )}
        </>
    )
}

export default ConfigFiltersMobile
